export const themeBreakpoints = {
  values: {
    xs: 375,
    sm: 670,
    md: 768,
    lg: 960,
    xl: 1920,
  },
};
